<template>
	<v-row>
		<EditSurvey v-if="id" :id="id"></EditSurvey>
	</v-row>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	import EditSurvey from "@/components/survey/EditSurvey"
	export default {
		name: "NewSurvey", 
		props: {
		},
		data: () => {
			return {
				id: null
			}
		},
		components: {
			EditSurvey
		},
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		
		created(){
			var id = this.generateId();
			var self = this;
			this.$store.dispatch("surveys/new", {id: id, title: "Untitled Survey" }).then(( ) => {
				self.id = id;
			})
		},
		destroyed(){

		}

	}
</script>